import React from 'react'

const Footer = () => {
  return (
    <footer className='bg-[#6F4E37]'>
      <div className='container mx-auto p-4'>
        <p className='text-center font-bold' title='youtube channel'>This is ARTWAVE</p>
      </div>
    </footer>
  )
}

export default Footer